import { useMutation } from 'react-query';

import type {
  TrialInviteCredentials,
  TrialSignupFormValues,
} from '../../schema/schema';
import { TRIAL_SIGNUP_QUERY_KEYS } from '../constants';
import {
  requestTrialSignup,
  type TrialRegisterResponse,
} from '../request';

type TrialSignupVariables = {
  values: TrialSignupFormValues;
  invite: TrialInviteCredentials;
  signal?: AbortSignal;
};

export const useTrialSignupMutation = () =>
  useMutation<TrialRegisterResponse, Error, TrialSignupVariables>(
    [TRIAL_SIGNUP_QUERY_KEYS.REGISTER],
    ({ values, invite, signal }: TrialSignupVariables) =>
      requestTrialSignup(values, invite, signal)
  );
